import React from "react";
import { cn } from "./utils"; // shadcn 預設提供的 className 合併工具

/**
 * ButtonGroup：shadcn 樣式的按鈕群組元件
 *
 * Props:
 * - direction: 'row' | 'column'（按鈕排列方向）
 * - gap: string | number（按鈕間距，如 '12px'、'1rem'）
 * - align: 'start' | 'center' | 'end'（主軸對齊方式）
 * - wrap: boolean（是否允許自動換行）
 * - visible: boolean（是否顯示整個群組）
 * - maxVisible: number（最多顯示幾個按鈕）
 * - children: ReactNode（按鈕們）
 * - className: 額外 className 傳入
 * - ...rest: 傳入每個子按鈕的額外 props
 */
const ButtonGroup = ({
  direction = "row",
  gap = "8px",
  align = "start",
  wrap = false,
  visible = true,
  maxVisible,
  children,
  className,
  ...rest
}) => {
  if (!visible) return null;

  const childrenArray = React.Children.toArray(children);
  const visibleChildren = typeof maxVisible === "number"
    ? childrenArray.slice(0, maxVisible)
    : childrenArray;

  const justifyClass = {
    start: "justify-start",
    center: "justify-center",
    end: "justify-end",
  }[align] || "justify-start";

  const flexClass = direction === "column" ? "flex-col" : "flex-row";
  const wrapClass = wrap ? "flex-wrap" : "flex-nowrap";

  const gapStyle = {
    gap: typeof gap === "number" ? `${gap}px` : gap,
  };

  return (
    <div
      className={cn(
        "flex",
        flexClass,
        wrapClass,
        justifyClass,
        className
      )}
      style={gapStyle}
    >
      {visibleChildren.map((child, index) =>
        React.cloneElement(child, {
          key: index,
          ...rest,
        })
      )}
    </div>
  );
};

export default ButtonGroup;
